// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-dialog--fullscreen[data-v-496c693a] {\n    border-radius: 0;\n    margin: 0;\n    height: 70%;\n    position: fixed;\n    overflow-y: auto;\n    top: 200px;\n    left: 0;\n}\n.custom-loader[data-v-496c693a] {\n    animation: loader-data-v-496c693a 1s infinite;\n    display: flex;\n}\n@keyframes loader-data-v-496c693a {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n", ""]);
// Exports
module.exports = exports;
